import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NameLocalStorage, RecordTitleSet } from '@app/models/record.model';
import { UserService } from '@app/services/dai.service';
import { RecordSelectors } from '@app/store/record/record.selectors';
import { SelectTitles } from '@app/store/setting/setting.classes';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-user-record-select',
  templateUrl: './user-record-select.component.html',
  styleUrls: ['./user-record-select.component.scss'],
})
export class UserRecordSelectComponent implements OnInit {
  titleSetList!: RecordTitleSet[];
  form!: FormGroup;
  historyBackWard = () => history.back();
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store,
    private userService: UserService
  ) { }
  get config() {
    return this.store.selectSnapshot(RecordSelectors.kirokuSetting) || null;
  }

  get isValid() {
    return this.userForm.value && this.records.length > 0
  }

  get records() {
    const records = this.titleSetList.map((titleSet, i) =>
      titleSet.titles.filter((_, j) => !!this.titleSetListForm.value[i][j])
    );
    return records.flat();
  }

  ngOnInit(): void {
    this.titleSetList = this.store.selectSnapshot(SettingSelectors.titleSetList);

    this.route.data.subscribe(() => {
      let selectUser = (this.userService.userList[0].daicd || '');
      if (this.config.daicds && this.config.daicds.length > 0) {
        selectUser = this.config.daicds[0]
      }

      this.form = this.fb.group({
        titleSetList: this.fb.array(
          this.titleSetList.map((titleSet) =>
            this.fb.array(titleSet.titles.map(() => null))
          )
        ),
        user: null
      });
    });
  }

  get userForm() {
    return this.form.get('user') as FormControl;
  }
  changeUser(user: string[]) {
    this.userForm.setValue(user[0] || undefined);
  }

  getForm(index: number) {
    return this.titleSetListForm.at(index) as FormArray;
  }


  onSubmit(): void {
    const objcd = this.userForm.value;
    const records = this.titleSetList.map((titleSet, i) =>
      titleSet.titles.filter((_, j) => !!this.titleSetListForm.value[i][j])
    );
    const selectedTitles = { objcd, items: this.records };
    this.store
      .dispatch(new SelectTitles(selectedTitles))
      .subscribe(() => {
        localStorage.setItem(NameLocalStorage.SELECTED_TITLES, JSON.stringify(selectedTitles));
        this.router.navigate(['', { outlets: { edit: ['record-add'] } }], { replaceUrl: true, queryParamsHandling: "preserve" })
      });
  }

  private get titleSetListForm() {
    return this.form.get('titleSetList') as FormArray;
  }
}
